import { useMemo, useState } from "react";
import { taskService } from "@miplatform/api";
import { ENTITY_TYPES, HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IAttempt, StepType } from "@miplatform/types";
import { useDocumentsViewModel } from "@miplatform/view-models";

export const useWorkOrderAttemptDocumentFormViewModel = ({
  attempt,
  onClose,
}: {
  attempt: IAttempt | null;
  onClose: () => void;
}) => {
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();
  const { loading, uploadDocument, getDocumentCategories } =
    useDocumentsViewModel();
  const [documentCategories, setDocumentCategories] = useState<any[]>([]);
  const step = useMemo(
    () => attempt?.steps.find((step) => step.stepType === StepType.Document),
    [attempt]
  );

  const getDocumentCategory = async () => {
    const categories = await getDocumentCategories(ENTITY_TYPES.STEP);

    if (categories) {
      setDocumentCategories(categories);
    }
  };

  const submitStepResult = async () => {
    stateManager.run(async () => {
      const response = await taskService.assignments.submitStepResult({
        attemptId: attempt?.id,
        assignmentId: attempt?.assignment?.id,
        stepId: step?.id,
        stepResultId: step?.stepResult?.id,
        data: {},
        toastMessageConfig: {
          success: {
            text: `Submitted Successfully`,
            subtext: `The step has been submitted successfully`,
          },
          error: {
            text: `Submission Failed`,
            subtext: `The step submission has failed. Please try again.`,
          },
        },
      });

      if (response.status === HTTP_STATUSES.OK) {
        onClose();
      }
    });
  };

  return {
    isLoading: isLoading || loading,
    documentCategories,
    step,
    getDocumentCategory,
    uploadDocument,
    submitStepResult,
  };
};
